import React from "react";
import { PageNewState, ComponentSearchDialogInitialState } from ".";

export const ComponentSearchDialogContext = React.createContext({
  pageState: ComponentSearchDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
